import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { MyInfoStyled } from '../../asset/styled/MyInfoStyled';

import exclamationIcon from '../../asset/img/common/excalmation_black_icon.svg';
import arrowRightIcon from '../../asset/img/common/arrow_right_icon.svg';
import basicImg from '../../asset/img/common/information_icon.svg';
import Title from './Title';
import PasswordChange from './PasswordChange';
import PersonalInfo from './PersonalInfo';
import Button from '../../components/common/Button';
import { logout } from '../login/loginSlice';
import { getInsaInfoLoad, resetMyInfoState } from './myInfoSlice';
import SlideRightDialog from '../../components/common/SlideRightDialog';

import Typography from '../../components/common/Typography';
import Terms from './terms';
import { getAlertMessageFunction } from '../../common/Util';
import { getHtmComPassCheck } from '../common/commonSlice';

const MyInfo = ({ isOpen = true, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('myInfo');
  const { t: tCommon } = useTranslation('common');
  const { reload, myInfo } = useSelector(state => state.myInfo);
  const htmComCd = myInfo?.htmComCd || '';
  //콘센트릭스는 비밀번호 예외
  const isCnxkr = htmComCd?.trim() == 'CNXKR' || htmComCd?.trim() == 'lime';
  const { agree } = useSelector(state => state.common);

  const [isTermsOpen, setIsTermsOpen] = useState(false);
  // const { logout } = useSelector(state => state.login);

  //동의하기 한 경우 초기 데이터 로드
  useEffect(() => {
    if (isOpen) {
      dispatch(getInsaInfoLoad());
    }
  }, [isOpen]);

  //개인정보 변경 후 데이터 재로드
  useEffect(() => {
    if (reload != -1) {
      dispatch(getInsaInfoLoad());
    }
  }, [reload]);

  //state 초기화
  useEffect(() => {
    return () => {
      dispatch(resetMyInfoState());
    };
  }, []);

  const handleLogoutClick = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('Logout');
    }
    dispatch(logout());
  };

  const handleClose = async () => {
    const alertMessage = getAlertMessageFunction();
    const response = await dispatch(getHtmComPassCheck()).unwrap();
    const { resultCode } = response;
    if (resultCode == '1') {
      //최초 설정된 비밀번호~~
      alertMessage(tCommon('alertMessage.passwordMessage1'));

      return;
    } else {
      if (onClose) onClose();
      else navigate('/');
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={handleClose} title={tCommon('header.title2')}>
      <MyInfoStyled>
        {/* myinfo title */}
        <Title />
        {/* 비밀번호 변경 */}
        {!isCnxkr && <PasswordChange title={t('passwordTitle')} />}
        {/* 개인정보수정 */}
        <PersonalInfo title={t('personalInfoTitle')} />
        {/* 약관 및 정책 */}
        <div className="termsAndPolicyBox" onClick={() => setIsTermsOpen(true)}>
          <div className="displayFlex" style={{ gap: '10px' }}>
            <img src={exclamationIcon} alt="exclamationIcon" />
            <Typography>약관 및 정책</Typography>
          </div>
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </div>
        {/* 로그아웃 */}
        <div className={'displayFlexColumn'} style={{ gap: '8px' }}>
          <Button size="large" value={t('logoutButton')} onClick={() => handleLogoutClick()} />
          <div className={'displayFlex'} style={{ gap: '4px' }}>
            <img src={basicImg} alt="Info" />
            <Typography {...{ variant: 'captionMedium', color: 'Primary-500' }}>
              {t('logoutMsg')}
            </Typography>
          </div>
        </div>

        <Terms isSlideOpen={isTermsOpen} isSlideClose={() => setIsTermsOpen(false)} />
      </MyInfoStyled>
    </SlideRightDialog>
  );
};

export default MyInfo;
